<template>
  <div>
    <h5 class="text-muted">{{ $t('Payment information') }}</h5>

    <div class="my-4">
      <div id="payment-element">
        <!--Stripe.js injects the Payment Element-->
      </div>
    </div>
  </div>
</template>

<script>
    export default {
        name: "Payment",
        props: {
            stripe : {
                required: true
            },
            clientSecret: {
                type: String,
                required: true
            },
            disabled: {
                type: Boolean,
                required: false
            }
        },
        data () {
            return {
                card : null,
                elements: null,
                paymentElement: null,
            }
        },
        watch : {
            stripe: function (stripe) {
                this.initStripe2();
            },
            disabled: function (disabled) {
                console.log('disabled', disabled);
                this.card.disabled = disabled
            }
        },
        methods: {
          async initStripe2(forceInit = false) {
            if(!this.stripe) {
              return;
            }
            if (this.elements && !forceInit) {
              return
            }

            if (this.paymentElement) {
              this.paymentElement.destroy();
            }

            this.elements = this.stripe.elements({ clientSecret : this.clientSecret });

            const paymentElementOptions = {
              layout: {
                type: 'accordion' // 'accordion' / "tabs",
              }
            };

            const paymentElement = this.elements.create("payment", paymentElementOptions);
            this.paymentElement = paymentElement.mount("#payment-element");

            paymentElement.on('change', (event) => {
              console.log('event', event);
              this.$emit('cardUpdated', event)
            });
          },

          async submitPayment() {
            this.$emit('processing')

            const { paymentIntent, error } = await this.stripe.confirmPayment({
              elements: this.elements,
              confirmParams: {
                // Make sure to change this to your payment completion page
                return_url: window.location.origin,
              },
              redirect: 'if_required'
            });

            if (error) {
              // Show error to your customer (e.g., insufficient funds)
              this.$notify({
                group: 'errors',
                type: 'error',
                title: error.message,
              });
              throw error;
            }

            this.$emit('pending')
            this.$emit('paymentIntent', paymentIntent)

            return paymentIntent;
          }
        },
        mounted() {
            this.initStripe2();
        }
    }
</script>